import { getIn } from "formik";
import { FormControl, FormLabel, FormHelperText, Radio, RadioGroup, FormControlLabel, Typography, InputLabel } from "@mui/material";
import CustomDivider from "../../utils/CustomDivider";

export const RadioButtonGroupFormField = ({
    field,
    form,
    label,
    options,
    row = false,
    isRequired = false,
    isId = false,
    disabled = false
}) => {
    const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);

    return (
        <FormControl
            component="fieldset"
            error={!!errorText} fullWidth
            disabled={disabled}
        >
            {label && (
                // <FormLabel component="legend" sx={{ mb: 1 }}>
                //   <Typography variant="h6" sx={{ textTransform: "capitalize" }}>
                //     {label}
                //     {isRequired && (
                //       <Typography variant="h5" color="error" component="span">
                //         {" *"}
                //       </Typography>
                //     )}
                //   </Typography>
                // </FormLabel>
                <InputLabel sx={{ ml: -1.6 }} shrink htmlFor={field.name}>
                    <Typography variant="h6" sx={{ textTransform: "capitalize" }}>
                        {label}
                        {isRequired && (
                            <Typography variant="h6" color="error" component="span">
                                {" *"}
                            </Typography>
                        )}
                    </Typography>
                </InputLabel>
            )}
            <CustomDivider size={"1rem"} />
            <RadioGroup
                row={row}
                value={field.value || ""}
                onChange={(e) => form.setFieldValue(field.name, e.target.value)}
                onBlur={() => form.setFieldTouched(field.name, true)}
            >
                {options.map((option) => {
                    const radioValue = isId ? option.id : option.value;
                    return (<FormControlLabel
                        key={radioValue}
                        value={radioValue}
                        control={
                            <Radio
                               disabled={disabled}  
                                sx={{
                                    color: "#4169E1",
                                    "&.Mui-checked": { color: "#4169E1" },
                                }}
                            />
                        }
                        label={
                            <Typography variant="h6">
                                {option.label}
                            </Typography>
                        }
                    />)
                })}
            </RadioGroup>

            {errorText && (
                <Typography variant="h6" fontSize={"10px"} color="red">
                    {errorText}
                </Typography>
            )}
        </FormControl>
    );
};
